export const MAX_ATTEMPTS = 3;
export const RETRY_DELAY_MS = 1000;
